import * as TYPES from '../types';
import { PracticeDataUpdateAction, PracticeDataUpdateActions, PracticeDataUpdateState } from '../types';
const initialState: PracticeDataUpdateState = {
  practiceDataUpdate: {
    _id: '',
    description: '',
    drills: [],
    intensity: '',
    league: '',
    name: '',
    profileName: '',
    rooftype: '',
    siteId: '',
    siteName: '',
    start: 0,
    teamId: '',
    type: '',
    season: '',
    __v: 0,
    currentDrill: '',
    currentDrillIndex: 0,
    dsUpdateTimeStampChange: false,
    isStarted: false,
    lastDrillIndex: 0,
    lastDrillStartTime: 0,
    stepIndex: 0,
    totalElapsedTime: 0,
    dataset_id: '',
    dataset_ref_id: '',
    end: 0,
    endScheduleTs: 0,
  },
  editableFlag: false,
  noSave: false,
};
export const practiceDataUpdate = (state =  initialState, action: PracticeDataUpdateActions ) => {
    switch(action.type){
        case PracticeDataUpdateAction.UPDATE_PRACTICE_DATA:
            return {...state, practiceDataUpdate: action.practiceDataUpdate};
        case PracticeDataUpdateAction.RESET_EDITABLE:
            return {...state, editableFlag: action.flag};
        case PracticeDataUpdateAction.NO_SAVE:
            return {...state, noSave: action.save};
        default:
            return state;
    }

};

